import { Outlet, useRouterState } from "@tanstack/react-router";
import { AuthLayout } from "@/components/layouts/AuthLayout";

const BARE_PATHS = new Set(["/auth/google/callback", "/health"]);

/**
 * Account-app shell: AuthLayout for auth/onboarding pages, bare outlet for
 * the Google OAuth callback (and health). Never mounts product dashboard chrome.
 */
export function AccountShell() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (BARE_PATHS.has(pathname)) {
    return <Outlet />;
  }

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
